import React  from "react";
import { useParams } from 'react-router-dom';
import LeaveForm from "./components/LeaveForm";
import Card from "components/card";

const EditLeave = () => {

	const { leaveId } = useParams();

	return (
	    <LeaveForm recordId={leaveId} mode="edit"/>
    );
};

export default EditLeave;